import menu from "./lib/menu";
import animadoAlAparecer from "./lib/animado-al-aparecer";
import formulario from "./lib/formulario";
import impacto from "./colabora/impacto";
import provincias from "./colabora/provincias";
import cantidades from "./colabora/cantidades";
import preguntasFrecuentes from "./colabora/preguntas-frecuentes";
import telefonos from "./colabora/telefonos";
import trivial from "./colabora/trivial";
require('../sass/app.scss');
var ajustaVw = function () {
    document.documentElement.style.setProperty('--vw', "".concat(document.documentElement.clientWidth, "px"));
};
var dataLayer = window.dataLayer;
addEventListener('resize', ajustaVw);
addEventListener('load', ajustaVw);
ajustaVw();
menu();
impacto();
formulario('form:not(.sin-ajax)', {
    dataLayer: dataLayer,
    ocultarEtiquetas: true,
    onInicializado: function () {
        cantidades();
        provincias();
    }
});
preguntasFrecuentes();
telefonos();
trivial();
animadoAlAparecer('.animado');
